module.exports = __webpack_public_path__ + "christmas-island.svg?18a45791bad1c71482c312c05b583d78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/christmas-island.svg
// module id = 136
// module chunks = 10